var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-youtube"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    clipPath: "url(#clip-youtube)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_simple-youtube",
    transform: "translate(3.245 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-youtube-2",
    d: "M28.312,9.336A4.19,4.19,0,0,0,25.8,6.181c-2.253-.757-11.322-.757-11.322-.757s-9.046-.015-11.322.757A4.19,4.19,0,0,0,.636,9.336a58.893,58.893,0,0,0-.629,8.771,58.89,58.89,0,0,0,.629,8.738A4.19,4.19,0,0,0,3.152,30c2.251.758,11.322.758,11.322.758s9.045,0,11.322-.758a4.19,4.19,0,0,0,2.516-3.155,58.911,58.911,0,0,0,.6-8.738,58.913,58.913,0,0,0-.6-8.771ZM11.58,23.532V12.664l7.548,5.442Z",
    transform: "translate(-0.007 -5.424)",
    fill: "#130f53"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.b06b62ef.svg";
export { ForwardRef as ReactComponent };